<template>
  <RowGrid class="LaptopProsAndCons" :columns="2">
    <Field
      :disabled="isLoading"
      :label="$t('pros')"
      type="textarea"
      :value="laptopPros"
      @update:value="updatePros" />
    <Field
      :disabled="isLoading"
      :label="$t('cons')"
      type="textarea"
      :value="laptopCons"
      @update:value="updateCons">
      <FieldBtn
        :isLoading="isLoading"
        @click="generateProsConsForLaptop">
        <Icon v-if="hasProsCons" name="brain" />
        {{ $t('generateProsCons') }}
      </FieldBtn>
    </Field>
  </RowGrid>
</template>

<script>
import { hasProsCons } from '@utils/laptops'

export default {
  props: {
    articleLaptop: { type: Object, required: true },
    laptop: { type: Object, required: true },
    isLoading: { type: Boolean, default: false },
  },
  computed: {
    hasProsCons() {
      return hasProsCons(this.laptop)
    },
    laptopPros() {
      return (this.articleLaptop.pros || []).join('\n')
    },
    laptopCons() {
      return (this.articleLaptop.cons || []).join('\n')
    },
  },
  methods: {
    generateProsConsForLaptop() {
      this.$emit('generateProsConsForLaptop', this.articleLaptop.laptopId)
    },
    updatePros(value) {
      this.$up('articleLaptop.pros', transformTextToArray(value))
    },
    updateCons(value) {
      this.$up('articleLaptop.cons', transformTextToArray(value))
    },
  },
}

const transformTextToArray = text => text ? text.split('\n') : []
</script>

<style lang="scss">
.LaptopProsAndCons {
  .Field-cont {
    margin: 0;
  }
}
</style>

<i18n>
{
  "en":{
    "pros": "Pros",
    "cons": "Cons",
    "generateProsCons": "Generate Pros and Cons"
  }
}
</i18n>
